

export const SERVICE_PROCESSING_WORKFLOW_TYPE = {
  INSTANT: 'instant',
  CONFIRM_DECLINE: 'confirm_decline',
}
